import {FreeRoundsScreenView} from '@fantasmagames/slot/src/modules/microgaming/freerounds/FreeRoundsScreenView';
import {SpineAnimation} from '@fantasmagames/core/src/display/SpineAnimation';
import {Spine} from '@fantasmagames/core/src/spine/Spine';

export class GameFreeRoundsScreenView extends FreeRoundsScreenView {
	protected showMenuAnimation(animationName: string, loop: boolean, stopOnComplete: boolean = true): SpineAnimation {
		if (this._mainAnimation) {
			this.spineUtils.stopAndDestroyAnimation(this._mainAnimation);
		}

		const spine: Spine = new Spine(this.resources.getSpine('FREE-GAMES_SCREENS.json'));
		this.setupElements(spine);
		this._mainAnimation = new SpineAnimation(spine, animationName, loop, true);
		this._mainAnimation.container.position.set(
			this.resolutionManager.halfResolution.width,
			this.resolutionManager.halfResolution.height,
		);

		const textureName: string = this.getTextureName();
		this.spineUtils.replaceElementInSpine(
			spine,
			'GAME_LOGOTYPE',
			new PIXI.Sprite(this.resources.getTexture(`${textureName}`)),
		);

		this.container.addChild(this._mainAnimation.container);
		if (stopOnComplete) {
			this._mainAnimation.setOnComplete(() => {
				this._mainAnimation.stop();
			});
		}

		this.updateManager.add(this._mainAnimation);
		this._mainAnimation.start();

		return this._mainAnimation;
	}

	protected getTextureName(): string {
		switch (this.resources.getLocale().toLowerCase()) {
			case 'zh-cn':
				return 'LOGO_ZH_CN.png';
			case 'zh-tw':
				return 'LOGO_ZH_TW.png';

			default:
				return 'LOGOTYPE.png';
		}
	}
}


// WEBPACK FOOTER //
// ./src/freerounds/GameFreeRoundsScreenView.ts